export default {"src":"/_next/static/media/logo.9cd85f54.svg","height":482,"width":605,"blurWidth":0,"blurHeight":0};